import { useState, useEffect } from 'react';

const LOGO_URL = "https://static.readdy.ai/image/a93fb4e9fe5360734eafc891174445c0/15d05a694e2d3c4a1b130743b9c65855.jpeg";

const navLinks = [
  { label: '課題', href: '#problem' },
  { label: '解決策', href: '#solution' },
  { label: 'サービス', href: '#service' },
  { label: '実績', href: '#trust' },
  { label: '無料診断', href: '#cta' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/97 backdrop-blur-sm border-b border-gray-100' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-10 flex items-center justify-between" style={{ height: '68px' }}>
        <button
          className="flex items-center gap-3 cursor-pointer"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <div className="w-9 h-9 flex items-center justify-center">
            <img src={LOGO_URL} alt="会議設計" className="h-9 w-auto object-contain rounded" />
          </div>
          <span
            className={`text-sm font-bold tracking-tight whitespace-nowrap transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            会議設計
          </span>
        </button>

        <div className="hidden md:flex items-center gap-7">
          {navLinks.slice(0, -1).map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-600 hover:text-[#C0392B]' : 'text-white/80 hover:text-white'
              }`}
              style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNav('#cta')}
            className="px-5 py-2 bg-[#C0392B] text-white text-sm font-bold rounded-md hover:bg-[#a93226] transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            無料診断（5分）
          </button>
        </div>

        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer transition-colors ${scrolled ? 'text-gray-700' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? 'close-line' : 'menu-line'} text-2xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-5 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className="text-sm font-medium text-gray-700 hover:text-[#C0392B] transition-colors text-left cursor-pointer whitespace-nowrap"
              style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
